import { render, staticRenderFns } from "./SpecialBrainGames.vue?vue&type=template&id=ae0eca78&scoped=true"
import script from "./SpecialBrainGames.vue?vue&type=script&lang=js"
export * from "./SpecialBrainGames.vue?vue&type=script&lang=js"
import style0 from "./SpecialBrainGames.vue?vue&type=style&index=0&id=ae0eca78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0eca78",
  null
  
)

export default component.exports